import { SxProps, Theme } from '@mui/material';

export const getAccordionHeaderSx = (
  showHeaderMargin: boolean
): SxProps<Theme> => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  marginBottom: showHeaderMargin ? '16px' : 0,
  transition: 'margin-bottom 0.3s ease'
});

export const accordionTitleSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: { xs: '20px', sm: '24px' },
  lineHeight: { xs: '28px', sm: '32px' },
  color: 'var(--color-primary)'
};

export const accordionChevronSx: SxProps<Theme> = {
  color: 'var(--color-primary)',
  fontSize: { xs: '20px', sm: '24px' },
  transition: 'transform 0.3s ease'
};

export const accordionContainerSx: React.CSSProperties = {
  width: '100%',
  backgroundColor: 'var(--color-white)',
  borderRadius: '12px',
  padding: '24px'
};

